import { useEffect, useMemo, useState } from 'react';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getCreativeTrendsStats } from '@opm/services';
import { useStableValue } from '@opm/utils/stableKey';
import { ICreativeTrendsStats } from '../types';

/**
 * 获取 StatusTab 各状态数量
 * - 依赖 filter + search_text（不受 statusTab/sort 影响）
 * - 在筛选器或搜索词变化时立即刷新
 */
export function useCreativeTrendsStats({
  filter,
  searchText = '',
}: {
  filter: any;
  searchText?: string;
}) {
  const [counts, setCounts] = useState<ICreativeTrendsStats>({
    hot: 0,
    rising: 0,
    new: 0,
  });
  const { wrapperCancelRequest, loading } = useCancelRequestHook({
    clear: () => setCounts({ hot: 0, rising: 0, new: 0 }),
  });

  const stableFilter = useStableValue(filter);
  const stableSearchText = useStableValue(searchText);

  const params = useMemo(() => {
    if (!stableFilter) return null;
    return {
      ...stableFilter,
      search_text: stableSearchText,
    };
  }, [stableFilter, stableSearchText]);

  useEffect(() => {
    if (!params) return;
    wrapperCancelRequest(getCreativeTrendsStats, params)
      .then((response: any) => {
        const { hot = 0, rising = 0, new: newCount = 0 } = response || {};
        setCounts({ hot, rising, new: newCount });
      })
      .catch(() => {});
  }, [params]);

  return { counts, loading };
}
